import { useEffect, useRef } from 'react';

/** Screen-level shortcuts. Ignored while typing in a field. Keys: "m", " ", "ArrowLeft", "shift+ArrowLeft"… */
export function useHotkeys(map: Record<string, (e: KeyboardEvent) => void>) {
  const ref = useRef(map);
  ref.current = map;
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (document.documentElement.dataset.tour === 'open') return;
      const el = e.target as HTMLElement | null;
      if (el && (el.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(el.tagName))) {
        const type = (el as HTMLInputElement).type;
        if (el.tagName !== 'INPUT' || !['range', 'checkbox', 'radio'].includes(type)) return;
      }
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      const key = (e.shiftKey ? 'shift+' : '') + (e.key.length === 1 ? e.key.toLowerCase() : e.key);
      const fn = ref.current[key];
      if (fn) {
        e.preventDefault();
        fn(e);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
}
